<template>
    <pop-up class="base-modal" v-model="showDialog" get-container="body" :close-on-click-overlay="false">
        <div class="content">
            <img class="icon" src="./img/fail.png" alt="" />
            <div class="title">认证失败</div>
            <div class="inner">
                <span>充值账号({{ phone }})<span>认证失败</span>，该账号无法购买此商品，请购买其他优惠商品吧~</span>
            </div>
            <div class="btn" @click="showDialog = false">我知道啦</div>
        </div>
    </pop-up>
</template>

<script>
import 'vant/lib/popup/style';
import Popup from 'vant/lib/popup';

export default {
    name: 'AlipayCertFailModal',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        phone: {
            type: String,
            default: '',
        },
    },
    components: {
        'pop-up': Popup,
    },
    data() {
        return {};
    },
    computed: {
        showDialog: {
            get() {
                return this.value;
            },
            set(newVal) {
                this.$emit('input', newVal);
            },
        },
    },
    methods: {
        handleClose() {
            this.showDialog = false;
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~root/blackcard/assets/styles/mixin.scss';
.base-modal {
    border-radius: 0.16rem;
    overflow: hidden;
    background: #ffffff;

    .content {
        width: 6.4rem;
        padding: 0.4rem 0.4rem 0.5rem;
        box-sizing: border-box;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .icon {
            width: 1.1rem;
            height: 1.1rem;
        }
        .title {
            height: 0.48rem;
            font-size: 0.32rem;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: #333333;
            line-height: 0.48rem;
            margin-top: 0.2rem;
        }
        .inner {
            height: 0.84rem;
            font-size: 0.28rem;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
            line-height: 0.42rem;
            margin-top: 0.3rem;
        }
    }
    .btn {
        width: 5.3rem;
        height: 0.9rem;
        border-radius: 0.45rem;
        font-size: 0.28rem;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #252220;
        line-height: 0.9rem;
        text-align: center;
        position: relative;
        @include border-1px(rgba(102, 102, 102, 1), 1rem);
        margin-top: 0.3rem;
    }
}
</style>
